import { reduxKey } from './constants';
function getState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export var getCurrentAdSafety = function (state) { return getState(state).currentSafety; };
export var getDeviationSafety = function (state) { return getState(state).deviationSafety; };
export var getQueuedDeviationId = function (state) { return getState(state).queuedDeviationId; };
//# sourceMappingURL=selectors.js.map